import { mergeClassnames } from '@heathmont/moon-core-tw';

type Props = { pageSection: PageSection };

const FiltersContainer: FC<Props> = ({ children, pageSection }) => (
  <div
    className={mergeClassnames(
      'grid grid-cols-[1fr_1fr] gap-1 md:grid-flow-col',
      getTemplateColumns(pageSection),
      getTemplateAreas(pageSection),
    )}
  >
    {children}
  </div>
);

const getTemplateAreas = (pageSection: string) => {
  if (pageSection === 'categories') {
    return '[grid-template-areas:"providers_providers"_"sort_sort"] md:[grid-template-areas:"providers_sort"]';
  }
  if (pageSection === 'providers') {
    return '[grid-template-areas:"categories_categories"_"sort_sort"] md:[grid-template-areas:"categories_sort"]';
  }
  return '[grid-template-areas:"providers_sort"_"categories_categories"] md:[grid-template-areas:"categories_providers_sort"]';
};

const getTemplateColumns = (pageSection: string) => {
  if (pageSection === 'categories' || pageSection === 'providers') {
    return 'md:grid-cols-[repeat(2,_12.5rem)]';
  }
  return 'md:grid-cols-[repeat(3,_12.5rem)]';
};

export default FiltersContainer;
